(() => {
  if (customElements.get('noonee-knowledge-hub')) return;
  class NooneeKnowledgeHub extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.grid = this.querySelector('[data-grid]');
      if (!this.grid) return;
      this.cards = [...this.querySelectorAll('[data-card]')].sort((a, b) => Number(a.dataset.order || 0) - Number(b.dataset.order || 0));
      this.cards.forEach(card => this.grid.appendChild(card));
      this.search = this.querySelector('[data-search]');
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.more = this.querySelector('[data-load-more]');
      this.empty = this.querySelector('[data-empty]');
      this.results = this.querySelector('[data-results]');
      this.category = 'all';
      this.pageSize = Math.max(3, Number(this.dataset.pageSize) || 6);
      this.visibleLimit = this.pageSize;
      this.search.addEventListener('input', () => { this.visibleLimit = this.pageSize; this.update(); }, options);
      this.filters.forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.filter;
        this.visibleLimit = this.pageSize;
        this.update();
        this.grid.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }, options));
      this.more.addEventListener('click', () => {
        const previous = this.visibleLimit;
        this.visibleLimit += this.pageSize;
        this.update();
        this.matches[previous]?.querySelector('a')?.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-reset]').addEventListener('click', () => this.reset(), options);
      this.querySelector('[data-show-all]').addEventListener('click', () => { this.reset(); this.visibleLimit = Infinity; this.update(); }, options);
      this.querySelector('[data-discovery]').hidden = false;
      this.querySelector('[data-show-all]').hidden = false;
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.initialized = false; }
    normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/ß/g, 'ss'); }
    reset() { this.search.value = ''; this.category = 'all'; this.visibleLimit = this.pageSize; this.update(); this.search.focus({ preventScroll: true }); }
    update() {
      const terms = this.normalize(this.search.value.trim()).split(/\s+/).filter(Boolean);
      this.matches = this.cards.filter(card => {
        const haystack = this.normalize(card.dataset.searchText || '');
        return (this.category === 'all' || card.dataset.category === this.category) && terms.every(term => haystack.includes(term));
      });
      const visible = new Set(this.matches.slice(0, this.visibleLimit));
      this.cards.forEach(card => { card.hidden = !visible.has(card); });
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
      this.more.hidden = this.matches.length <= this.visibleLimit;
      this.empty.hidden = this.matches.length > 0;
      this.results.hidden = false;
      const template = this.matches.length === 1 ? this.results.dataset.one : this.results.dataset.many;
      this.results.textContent = template.replace('[count]', String(this.matches.length));
    }
  }
  customElements.define('noonee-knowledge-hub', NooneeKnowledgeHub);
})();
